import { FC, Fragment } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
// Types
import UserRoles from 'app/types/UserRoles';
// Models
import { IMyUser } from 'app/models/User';
// Redux
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectMyUser } from 'app/store/Users/Users.selectors';
// Mui
import { Divider, ListItemButton, ListItemText } from '@mui/material';

type Props = {
  onClose: () => void;
}

const AccountManagerMenuItems:FC<Props> = ({ onClose }) => {
  const { t } = useTranslation();
  // State
  const myUser:IMyUser | null = useAppSelector(selectMyUser);

  const listItems = [
    { to: '/am/company-accounts', type: 'item', label: t('components.userDrawer.companyAccounts') },
    { to: '/am/users', type: 'item', label: t('components.userDrawer.users') },
    { to: '/am/billing-and-subscriptions', type: 'item', label: t('components.userDrawer.billingAndSubscriptions') },
    { to: '/am/subscription-packages', type: 'item', label: t('components.userDrawer.subscriptionPackages') },
    { to: '/am/billing-orders', type: 'item', label: t('components.userDrawer.orders') },
    { to: '/am/billing-services', type: 'item', label: t('components.userDrawer.services') },
    { to: '/am/terms-and-conditions', type: 'item', label: t('components.userDrawer.termsAndConditions') },
    { to: '/am/ai-prompt-hub', type: 'item', label: t('components.userDrawer.aiPromptHub') },
    { type: 'divider' }
  ];

  if ( !myUser || myUser.role !== UserRoles.AccountManager ) return null;
  return (
    <Fragment>
      {listItems.map((listItem:any, index:number) => {
        if ( listItem.type === 'divider' ) return (
          <Divider key={`user menu list divider ${index}`} component="li" />
        );
        return (
          <ListItemButton
            key={`user menu list item ${index}`}
            component={Link}
            to={listItem.to}
            onClick={onClose}
            sx={{ textTransform: 'capitalize' }}
          ><ListItemText primary={listItem.label} /></ListItemButton>
        );
      })}
    </Fragment>
  );
}

export default AccountManagerMenuItems;
